/**
 * Customiser cart integrity.
 * Keeps customisation fee line items consistent with their parent product:
 *  - Removes orphaned fees (whose parent product is no longer in the cart).
 *  - Syncs fee quantity to (parent quantity x fee-per-unit) when the parent's
 *    quantity changes.
 *
 * Fees are matched to parents by the `_customization_id` line-item property.
 * `_fee_per_unit` (set by the customiser at add time) is how many fee units one
 * parent unit represents (1 for embroidery, icon count for patches).
 *
 * Loaded on the cart page and cart drawer.
 */
(function () {
  if (window.__customiserCartSync) return;
  window.__customiserCartSync = true;

  var busy = false;

  function syncFees() {
    if (busy) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;

        /* Parent (non-fee) products by customization id -> quantity */
        var parentQty = {};
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (p['_customization_id'] && p['_is_customisation_fee'] !== 'true') {
            parentQty[p['_customization_id']] = it.quantity;
          }
        });

        /* Decide updates for each fee item */
        var updates = {};
        var changed = false;
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (p['_is_customisation_fee'] !== 'true') return;
          var cid = p['_customization_id'];
          var qty = parentQty[cid];
          if (!qty) {
            /* orphaned fee — remove */
            updates[it.key] = 0;
            changed = true;
          } else {
            var perUnit = parseInt(p['_fee_per_unit'], 10) || 1;
            var desired = perUnit * qty;
            if (it.quantity !== desired) {
              updates[it.key] = desired;
              changed = true;
            }
          }
        });

        if (!changed) return;

        busy = true;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            busy = false;
            /* Refresh the cart UI (page or drawer) without a full reload if possible */
            var ci = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
            if (ci && typeof ci.getCart === 'function') {
              try { ci.getCart(); return; } catch (e) {}
            }
            window.location.reload();
          })
          .catch(function () { busy = false; });
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', syncFees);
  /* Broadcast cart-change events */
  document.addEventListener('theme:cart:change', syncFees);
  document.addEventListener('theme:cart:reload', syncFees);
  document.addEventListener('theme:product:added', syncFees);
})();
